/* =============================================
   BACKGROUND PARALLAX BLOB SYSTEM
   ============================================= */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const blobs = document.querySelectorAll('.site-background .blob');
  if (!blobs.length) return;

  const speeds = [0.05, 0.08, 0.12, 0.06];
  const offsets = [
    { x: 0.03, y: 1 },
    { x: -0.05, y: 1 },
    { x: 0.04, y: 1 },
    { x: -0.03, y: 1 }
  ];

  let ticking = false;

  function updateBlobs() {
    const scrollY = window.scrollY;

    blobs.forEach((blob, i) => {
      const speed = speeds[i] || 0.05;
      const offset = offsets[i] || { x: 0, y: 1 };
      const yMove = scrollY * speed * offset.y;
      const xMove = scrollY * speed * offset.x;
      blob.style.transform = `translate3d(${xMove}px, ${yMove}px, 0)`;
    });

    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateBlobs);
      ticking = true;
    }
  });
})();
